export const isWordChain = (buzz) =>
  (buzz?.sub_buzzes || []).some((sb) => sb.bfp_data?.format_name === 'word_chain');

export const isHuedoku = (buzz) =>
  (buzz?.sub_buzzes || []).some(
    (sb) => sb.bfp_data?.format_name === 'game' && sb.bfp_data?.data?.type === 'huedoku'
  );

export const isSoupOfTheDay = (buzz) =>
  (buzz?.sub_buzzes || []).some(
    (sb) => sb.bfp_data?.format_name === 'game' && sb.bfp_data?.data?.type === 'soup_of_the_day'
  );

export const isGeotemp = (buzz) =>
  (buzz?.sub_buzzes || []).some(
    (sb) => sb.bfp_data?.format_name === 'game' && sb.bfp_data?.data?.type === 'geo_temp'
  );
